export default __webpack_public_path__ + "static/media/093-turn-right-2.f887dd87.png";